import type { ProductsCategoryV2 } from '../model/types'
import { useApi } from '@shared/api'

export interface FavoritePayload {
  id: number
  type: 'single' | 'group' | 'combo'
  institutionId: number
}

/**
 * API-клиент избранного.
 * Базовый URL: /api/v2/favorites
 */
class APIFavorite {
  private readonly basePath = '/favorites'

  /**
   * Добавить продукт или группу в избранное.
   * POST /api/v2/favorites
   */
  async addToFavorites({ id, type, institutionId }: FavoritePayload): Promise<{ message: string }> {
    const body: Record<string, any> = { institution_id: institutionId, item_type: type }
    if (type === 'single') body.product_id = id
    else if (type === 'group') body.group_id = id
    else body.combo_id = id

    const response = await useApi(true).post<{ message: string }>(this.basePath, { body })
    return response.data
  }

  /**
   * Удалить продукт или группу из избранного.
   * DELETE /api/v2/favorites
   */
  async removeFromFavorites({ id, type, institutionId }: FavoritePayload): Promise<{ message: string }> {
    const body: Record<string, any> = { institution_id: institutionId, item_type: type }
    if (type === 'single') body.product_id = id
    else if (type === 'group') body.group_id = id
    else body.combo_id = id

    const response = await useApi(true).delete<{ message: string }>(this.basePath, { body })
    return response.data
  }

  /**
   * Получить избранное в формате категорий.
   * GET /api/v2/favorites?institution_id=
   */
  async getFavorites(institutionId: number): Promise<{ categories: ProductsCategoryV2[] }> {
    if (!institutionId || Number.isNaN(institutionId)) {
      throw new TypeError('institutionId must be a valid number')
    }

    const response = await useApi(true).get<{ categories: ProductsCategoryV2[] }>(this.basePath, {
      params: { institution_id: institutionId },
    })

    if (!Array.isArray(response.data?.categories)) {
      throw new TypeError('Invalid favorites format: expected categories array')
    }

    return response.data
  }
}

export const apiFavorite = new APIFavorite()
export default apiFavorite
